import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 10em 0 5em 0;

	.content-container {
		background-color: #ffffff;
		padding: 2.5em 0;
	}

	.headline {
		font-size: 2em;
		font-weight: 700;
		text-align: center;
		line-height: normal;
	}

	@media all and (max-width: ${vars.tabletS}) {
        padding:0;

        .layout-container {
            width: 100%;
        }

		.content-container {
			padding: 0;
		}

		.headline {
			display: none;
		}
	}
`;
